export default "__VITE_ASSET__f059ded2__"